import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { CheckIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import useCanvasId from '../../utils/useCanvasId.js';
import Chip from '../Chip.js';

var _excluded = ["disabled", "className", "children", "id", "label", "value", "checked", "defaultChecked", "onChange", "onClick", "onUpdate", "required", "size", "error"];
var InputChip = function InputChip(props) {
  var disabled = props.disabled,
    className = props.className,
    children = props.children,
    id = props.id,
    label = props.label,
    value = props.value,
    checked = props.checked,
    defaultChecked = props.defaultChecked,
    onChange = props.onChange,
    onClick = props.onClick,
    onUpdate = props.onUpdate,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size;
    props.error;
    var otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('InputChip', otherProps);
  var uuid = useCanvasId(id, 'chip');
  var _useState = useState(typeof checked === 'boolean' ? checked : typeof defaultChecked === 'boolean' ? defaultChecked : false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  useEffect(function () {
    if (typeof checked === 'boolean' && checked !== isChecked) {
      setIsChecked(checked);
    }
  }, [checked, isChecked, setIsChecked]);
  var formChipClasses = classnames('C-InputChip', {
    isDisabled: disabled
  }, className);
  var handleOnChange = function handleOnChange(event) {
    setIsChecked(event.target.checked);
    onUpdate && onUpdate(otherProps.name || id, event.target.checked);
    onChange && onChange(event);
  };
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: formChipClasses
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    id: id ? id : uuid,
    className: "C-InputChip__Input",
    type: "checkbox",
    disabled: disabled,
    onClick: onClick,
    checked: isChecked,
    onChange: handleOnChange,
    value: value,
    required: required,
    "aria-required": required ? 'true' : 'false'
  }, otherProps)), /*#__PURE__*/React__default.createElement(Chip, {
    size: size,
    disabled: disabled,
    clickable: true,
    as: "div"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "C-InputChip__Icon"
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: CheckIcon
  })), label || children));
};
InputChip.displayName = 'Input.Chip';

export { InputChip as default };
